import { Box, Button, Paper, TextField, Typography, Snackbar, MenuItem, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import styles from '../../../styles.module.css'
import { Breadcrumb, Cancel, CTSinput, useMessageHandler, HandleCloseSnackbar, ActionMsg } from "../../reusableComponent/Reusables";
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DescriptionIcon from '@mui/icons-material/Description';
import { useDispatch, useSelector } from "react-redux";
import { addUOM, editDeleteUOM } from "../../../actions/actions";
import dayjs from "dayjs";
import uomMasterService from "../../../services/masters/uomMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

// ── CSS Styles ─────────────────────────────────────────────────────────────
// 1. Page wrapper
const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

// 2. Breadcrumb
const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

// 3. Page Header row
const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

// Page title
const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

// Back button
const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

// 4. Main form card
const formCardSx = {
  background: "#fff",

  border: "1px solid #E2E8F0",
  overflow: "hidden",
};

// 5. Section header bar (navy strip at top)
const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

// 6. Form body padding
const formBodySx = { padding: "22px 24px" };

// 7. Field label
const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

// 8. MUI TextField override
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

// 9. MenuItem style
const menuItemSx = { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" };

// 10. Form footer
const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

// 11. Save button
const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  fontFamily: "'Inter', Arial, sans-serif",
  borderRadius: "8px",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

// 12. Cancel button
const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
};

// ─────────────────────────────────────────────────────────────────────────────

const UOMAdd = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;
    let navigate = useNavigate();
    const { handleSubmit } = useForm();
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.uom_id : null;
    const [data, setData] = useState({
        uom: editData ? editData.uom : '',
        material_type: editData ? editData.material_type : '',
    });

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const [successMessage, setSuccessMessage] = useState(null);

    const onSubmit = async (event) => {
        const uomData = {
            ...data,
            modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            modified_by: editData ? userInfo.user_id : null,
            created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            created_by: editData ? editData.created_by : userInfo.user_id,
            uom_id: editid,
            changedUpdatedValue: 'edit'
        }
        try {
            if (editData) {
                await uomMasterService.editDeleteUOM(uomData);
            } else {
                await uomMasterService.addUOM(uomData);
            }
            setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
            setTimeout(() => navigate(-1), 1000);
        } catch (error) {
            setSuccessMessage("Error occurred");
        }
    };

    const materialOptions = [
        { label: "FG", value: "fg" },
        { label: "Rm", value: "rm" },
    ];

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <Box sx={pageSx}>
            {/* Breadcrumb */}
            <Box sx={breadcrumbSx}>
                <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>UOM</span>
            </Box>

            {/* Page Header */}
            <Box sx={pageHeaderSx}>
                <Box sx={pageTitleSx}>
                    <DescriptionIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
                    {editData ? 'UPDATE' : 'ADD'} UOM MASTER
                </Box>
                <Button onClick={handleBack} sx={backBtnSx}>
                    <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
                </Button>
            </Box>

            {/* Main Form Card */}
            <Box sx={formCardSx}>
                {/* Navy Strip Header */}
                <Box sx={sectionHeaderSx}>
                    <DescriptionIcon sx={{ fontSize: 18, color: "#fff" }} />
                    <Typography sx={sectionHeaderTitleSx}>UOM Master</Typography>
                </Box>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={formBodySx}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <Box>
                                    <Typography sx={fieldLabelSx}>
                                        UOM <span style={{ color: "#E53E3E", fontSize: "13px" }}>*</span>
                                    </Typography>
                                    <TextField
                                        size='small'
                                        fullWidth
                                        type="text"
                                        onChange={handleChange}
                                        name="uom"
                                        value={data.uom}
                                        required
                                        sx={inputSx}
                                        placeholder="Enter UOM (e.g., KG, LTR, PCS)"
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Box>
                                    <Typography sx={fieldLabelSx}>
                                        Material Type <span style={{ color: "#E53E3E", fontSize: "13px" }}>*</span>
                                    </Typography>
                                    <Autocomplete
                                        options={materialOptions}
                                        fullWidth
                                        getOptionLabel={(option) => option.label}
                                        value={materialOptions.find((opt) => opt.value === data.material_type) || null}
                                        onChange={(event, newValue) => {
                                            handleChange({
                                                target: {
                                                    name: "material_type",
                                                    value: newValue ? newValue.value : "",
                                                },
                                            });
                                        }}
                                        renderOption={(props, option) => (
                                            <MenuItem {...props} sx={menuItemSx}>
                                                {option.label}
                                            </MenuItem>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                fullWidth
                                                required
                                                sx={inputSx}
                                                placeholder="Select material type"
                                            />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* Form Footer */}
                    <Box sx={formFooterSx}>
                        <Button sx={cancelBtnSx} onClick={handleBack}>
                            Cancel
                        </Button>
                        <Button type="submit" sx={saveBtnSx}>
                            <SaveIcon sx={{ fontSize: 18 }} />
                            {editData ? "Update" : "Save"}
                        </Button>
                    </Box>
                </form>
            </Box>

            <ReusableSnackbar
                open={!!successMessage}
                onClose={(event, reason) => {
                    if (reason !== 'clickaway') {
                        setSuccessMessage("");
                    }
                }}
                message={successMessage}
                autoHideDuration={2000}
                vertical="top"
                horizontal="right"
            />
        </Box>
    )
}

export default UOMAdd;